module.exports = __webpack_public_path__ + "img/bg.b6c5276b.jpg";